<template>
    <div class="socialmedia">
        <div class="field-checkboxes field-checkboxes--large">
            <ul class="field-checkboxes__list">
                <li v-for="item in items" v-bind:key="item.id" class="field-checkboxes__list-item">
                    <input
                        :id="item.id"
                        type="checkbox"
                        :checked="isItemChecked(item.id)"
                        @change="checkItem(item.id, $event)"
                        class="field-checkboxes__input"
                    />
                    <label :for="item.id" class="field-checkboxes__label"
                        ><span class="field-checkboxes__pseudo-checkbox"></span
                        >{{ item.data.name }}</label
                    >
                    <div class="field-checkboxes__details">
                        <ul v-show="isItemChecked(item.id)">
                            <li class="socialmedia__row">
                                <app-text
                                    label="Link"
                                    :data-source="
                                        'deha.user.misc.socials.' + item.id + '.data.link'
                                    "
                                    :data-default="
                                        'deha.user.misc.socials.' + item.id + '.data.link'
                                    "
                                    pattern="^(https?:\/\/(www\.)?)?[\-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([\-a-zA-Z0-9@:%_\+.~#?\&\/\/=]*)$"
                                    :maxlength="255"
                                    :required="isItemChecked(item.id)"
                                    revalidate-target="social-media-link"
                                ></app-text>
                            </li>
                        </ul>
                        <ul v-show="!isItemChecked(item.id)">
                            <li class="socialmedia__row socialmedia__row--closed"></li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { toArray } from '@/helpers/utils';
import { ComplexFieldMixin } from '@/mixins/ComplexFieldMixin';
import { EventBus } from '@/helpers/event-bus';
import Text from '@/components/fields/simple/Text.vue';

export default {
    data() {
        return {};
    },
    components: {
        'app-text': Text
    },
    methods: {
        ...mapActions(['initOrUpdateList', 'setProp']),
        /* init */
        async init() {
            await this.initOrUpdateList({
                dataSource: this.dataSource,
                dataPreset: this.dataPreset,
                default: this.default
            });
        },
        /* validate */
        validate(val) {
            return !this.required || toArray(val).some((i) => i.visible);
        },
        /* custom setters */
        async checkItem(id, e) {
            await this.componentDifferChange();
            await this.setProp({
                source: this.dataSource + '.' + id + '.visible',
                value: e.target.checked
            });
            if (e.target.checked === false) {
                await this.setProp({
                    source: this.dataSource + '.' + id + '.data.link',
                    value:
                        'https://www.' +
                        this.getProp(this.dataSource + '.' + id + '.data.name').toLowerCase() +
                        '.com'
                });
            }
            EventBus.$emit('revalidate', 'social-media-link');
            await this.componentDifferValidate();
        },
        /* custom getters */
        isItemChecked(id) {
            return toArray(this.getProp(this.dataSource)).some(
                (i) => i.id === id && i.visible === true
            );
        }
    },
    computed: {
        ...mapGetters(['getProp']),
        items() {
            return toArray(this.getProp(this.dataSource)).sort((a, b) => a.pos - b.pos);
        }
    },
    props: {
        dataSource: String,
        dataPreset: String,
        required: Boolean,
        default: String
    },
    mixins: [ComplexFieldMixin]
};
</script>
